import classNames from 'classnames';
import { FlexContainer, PropertyBlock, PropertyPrice } from 'components';
import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';
import { useSearchPropertyViewState } from '../../state';
import { usePublicAccount, useDataActions } from 'state';
import styles from './PropertiesList.module.scss';

/**
 * PropertiesList
 *
 * @return {JSX.Element}
 */
const PropertiesList = ({ className, data, onBeforeClick }) => {
  const storageActions = useDataActions();
  const searchPropertyViewState = useSearchPropertyViewState();
  const publicAccountDoc = usePublicAccount();

  const handlePropertyClick = useCallback(
    (i) => () => {
      onBeforeClick?.(i);
      searchPropertyViewState.open(i);
    },
    [searchPropertyViewState, onBeforeClick]
  );

  const handleSave = useCallback(
    (propertyDoc) => (e) => {
      storageActions.property.toggleSaved(propertyDoc);
      // savedPropertiesState.toggleProperty(i.propertyUid);
      e.stopPropagation();
    },
    [storageActions.property]
  );

  return (
    <FlexContainer
      className={classNames(
        styles.PropertiesList,
        className,
        PropertiesList.displayName
      )}
      wrap
      gap
    >
      {data.map((i) => {
        const isSaved = publicAccountDoc.data?.savedPropertyUids.includes(i.id);
        return i.error ? null : (
          <PropertyBlock
            className={classNames(styles.Item, isSaved && styles.Item__saved)}
            key={i.data.propertyUid}
            bathroomCount={i.data.bathroomCount}
            bedroomCount={i.data.bedroomCount}
            imageUrls={i.data.imageUrls}
            title={i.data.address?.name}
            subTitle={<PropertyPrice value={i.data.tenancyRentAmount} />}
            onClick={handlePropertyClick(i)}
            actions={[
              {
                key: 'save',
                onClick: handleSave(i),
                icon: isSaved ? 'heartFill' : 'heartOutline',
              },
            ]}
          />
        );
      })}
    </FlexContainer>
  );
};

PropertiesList.displayName = 'PropertiesList';

export default observer(PropertiesList);
